import { render } from "./RedeemOrderButton.vue?vue&type=template&id=bfe1cb58"
import script from "./RedeemOrderButton.vue?vue&type=script&lang=js"
export * from "./RedeemOrderButton.vue?vue&type=script&lang=js"

import "./RedeemOrderButton.vue?vue&type=style&index=0&id=bfe1cb58&lang=less"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__